import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerShadow: {
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowRadius: 3,
    shadowOpacity: 0.6,
    marginHorizontal: 1,
  },
  containerAnimated: {
    elevation: 2,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
});
